import documents from '../modules/documents/locales/en.json';
import forms from '../modules/forms/locales/en.json';
import settings from '../modules/settings/locales/en.json';
import employee from '../modules/employee/locales/en.json';
import upgrade from '../modules/upgrade/locales/en.json';
import staticPage from '../modules/static/locales/en.json';
import common from './common.json';
import employeeSelfServe from '../modules/employee-self-serve/locales/en.json';

const combined = {
  common,
  ...documents,
  ...forms,
  ...settings,
  ...employee,
  ...upgrade,
  ...staticPage,
  ...employeeSelfServe,
};

export default combined;
